import enumSports from '@/data/enumSports.json'

const getPathSportIconById = function (idSport) {
  if (enumSports[idSport] && enumSports[idSport].icon) {
    return 'sports/' + enumSports[idSport].icon
  } else {
    return 'sports/other.svg'
  }
}
const getSportLabel = function (idSport) {
  if (enumSports[idSport] && enumSports[idSport].label) {
    return enumSports[idSport].label
  } else {
    return 'AUTRES'
  }
}

export {
  getSportLabel, getPathSportIconById
}
